export class ReceivedOrder {
    PartnerId: string;
    PartnerName: string;
    CheckoutCommonFields: CheckoutCommonField[];
}

export class CheckoutCommonField {
    FieldName: string;
    Value: any;
    ErrorMessage?: string;
}

export class CheckoutCommonFields {
    static PoInfoPoFile = "poInfoPoFile";
    static PoInfoPoFileName = "poInfoPoFileName";
    static PoInfoPoNumber = "poInfoPoNumber";
    static BuyersEmail = "buyersEmail";
    static ShipToCompanyName = "shipToCompanyName";
    static ShipToStreet = "shipToStreet";
    static ShipToCity = "shipToCity";
    static ShipToStateOrProvince = "shipToStateOrProvince";
    static ShipToZipOrPostal = "shipToZipOrPostal";
    static ShipToCountry = "shipToCountry";
    static BillToCompanyName = "billToCompanyName";
    static BillToStreet = "billToStreet";
    static BillToCity = "billToCity";
    static BillToStateOrProvince = "billToStateOrProvince";
    static BillToZipOrPostal = "billToZipOrPostal";
    static BillToCountry = "billToCountry";
    static ShipVia = "shipVia";
    static ShippingNotes = "shippingNotes";
    static DeliveryTerms = "deliveryTerms";
    static MarkedPackages = "markedPackages";
    static CollectAccountNumber = "collectAccountNumber";
    static CollectCarrier = "collectCarrier";
    static RequestedShipDate = "requestedShipDate";
}

export const requiredCheckoutCommonFieldNames = [
    CheckoutCommonFields.PoInfoPoFile,
    CheckoutCommonFields.PoInfoPoFileName,
    CheckoutCommonFields.PoInfoPoNumber,
    CheckoutCommonFields.BuyersEmail,
    CheckoutCommonFields.ShipToCompanyName,
    CheckoutCommonFields.ShipToStreet,
    CheckoutCommonFields.ShipToCity,
    CheckoutCommonFields.ShipToStateOrProvince,
    CheckoutCommonFields.ShipToZipOrPostal,
    CheckoutCommonFields.ShipToCountry,
    CheckoutCommonFields.BillToCompanyName,
    CheckoutCommonFields.BillToStreet,
    CheckoutCommonFields.BillToCity,
    CheckoutCommonFields.BillToStateOrProvince,
    CheckoutCommonFields.BillToZipOrPostal,
    CheckoutCommonFields.BillToCountry,
    CheckoutCommonFields.ShipVia,
    CheckoutCommonFields.ShippingNotes,
    CheckoutCommonFields.DeliveryTerms,
    CheckoutCommonFields.MarkedPackages,
    CheckoutCommonFields.CollectAccountNumber,
    CheckoutCommonFields.CollectCarrier,
    CheckoutCommonFields.RequestedShipDate
];